var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('div',{staticClass:"subtitle"},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions"},[_vm._t("actions")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e439022","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/page/PageHeader.vue
// module id = null
// module chunks = 